import { Category } from 'src-adisco/interfaces/categories';

export function getProductsInCategory(categories: Category[]): Category[] {
    return categories.map((el: any) => {
        if (el.subcategoryList?.length) {
            el.subcategoryList = getProductsInCategory(el.subcategoryList);
        }

        if (el?.linkProduct?.length || el.subcategoryList?.length) {
            return el;
        }

        return null;
    }).filter(el => el !== null);
}

export function findCategoryByTree(code: string, tree: Category[]): any {
    for (const el of tree) {
        if (el.codeCategory === code) {
            return el;
        } else if (el.subcategoryList?.length) {
            const found = findCategoryByTree(code, el.subcategoryList);
            if (found) {
                return found;
            }
        }
    }
    return null;
}

export function buildCategoryHierarchy(categories: Category[]): Category[] {
    const hierarchy: Category[] = [];
    let currentLevel1: Category | null = null;
    let currentLevel2: Category | null = null;

    categories?.forEach((category: any) => {
        const level = category?.categoryLevelCategory;

        if (level === 1) {
            currentLevel1 = { ...category, subcategoryList: [] };
            hierarchy?.push(currentLevel1!);
            currentLevel2 = null;
        } else if (level === 2 && currentLevel1) {
            currentLevel2 = { ...category, subcategoryList: [] };
            currentLevel1?.subcategoryList?.push(currentLevel2!);
        } else if (level === 3 && currentLevel2) {
            currentLevel2.subcategoryList.push(category);
        }
    });

    return hierarchy;
}

export function removeDuplicatesAndSort(items: any[]) {
    const uniqueItems = new Map();
    items.forEach((item) => {
        uniqueItems.set(item?.documentId, item);
    });

    return Array.from(uniqueItems.values()).sort((a, b) => a.value.localeCompare(b.value));
}

export function findMatchingNodes(tree: any[], itemsArray: any[]): any[] {
    
    function findNodeInTree(node: any, documentId: string): any | null {
        if (node.id === documentId) {
            return node;
        }

        if (Array.isArray(node.subcategoryList)) {
            for (let subNode of node.subcategoryList) {
                const foundNode = findNodeInTree(subNode, documentId);
                if (foundNode) {
                    return foundNode;
                }
            }
        }

        return null;
    }

    return itemsArray
        .map((item) => {
            return tree.reduce((foundNode, rootNode) => {
                return foundNode || findNodeInTree(rootNode, item?.documentId);
            }, null);
        })
        .filter((item) => item !== null);
}

export function flatCategories(tree: any) {
    let flatArray: any = [];

    function flatten(node: any) {
        flatArray.push(node);
        if (node.subcategoryList && node.subcategoryList.length > 0) {
            node.subcategoryList.forEach((child: any) => flatten(child));
        }
    }

    tree.forEach((nodeRoot: any) => flatten(nodeRoot));

    return flatArray;
}


export function buildCategoryHierarchyRandom(categories: Category[]): Category[] {
    const hierarchy: Category[] = [];
    let currentLevel1: Category | null = null;
    let currentLevel2: Category | null = null;

    categories?.forEach((category: any) => {
        const level = category?.categoryLevelCategory;
        if (level === 1) {
            currentLevel1 = { ...category, subcategoryList: [] };
            hierarchy?.push(currentLevel1!);
            currentLevel2 = null;
        }
    });
    categories?.forEach((category) => {
        const level = category?.categoryLevelCategory;

        if (level === 2) {
            hierarchy.forEach(cate=>{
                const resullt = category.attachmentCategory?.[0]?.documentId === cate.id
                if(resullt){
                    cate.subcategoryList.push({ ...category, subcategoryList: [] })
                }
            })
        }
    });

    categories?.forEach((category) => {
        const level = category?.categoryLevelCategory;
        if (level === 3) {
            hierarchy.forEach(cate => {
                cate.subcategoryList.forEach(subCate => {
                    const result = category.attachmentCategory?.[0]?.documentId === subCate.id;
                    if (result) {
                        subCate.subcategoryList.push(category);
                    }
                });
            });
        }
    });

    //SORT 
    
    hierarchy.sort((a, b) => {
        return a?.codeCategory.localeCompare(b?.codeCategory, undefined, { numeric: true, sensitivity: 'base' });
    });

    hierarchy.forEach(cate => {
        cate.subcategoryList.sort((a, b) => {
            return a?.codeCategory.localeCompare(b?.codeCategory, undefined, { numeric: true, sensitivity: 'base' });
        });

        cate.subcategoryList.forEach(subCate => {
            subCate.subcategoryList.sort((a, b) => {
                return a?.codeCategory.localeCompare(b?.codeCategory, undefined, { numeric: true, sensitivity: 'base' });
            });
        });
    });

    return hierarchy;
}

export function buildUrlWithNewParams(filter: any): string {
    const currentUrl = window.location.pathname;
    const queryParams = new URLSearchParams(window.location.search);

    queryParams.set('filter', JSON.stringify(filter));

    const url = `${currentUrl}?${queryParams.toString()}`;
    return encodeURI(url);
}

export function handleRemoveProperties(filter:any){
    return Object.fromEntries(
        Object.entries(filter).filter(([_, value]) => {
            return (
                value != null &&
                value !== '' &&
                (!Array.isArray(value) || value.length > 0) &&
                (typeof value !== 'object' || Object.keys(value).length > 0)
            );
        })
    );
}